// extracted by mini-css-extract-plugin
module.exports = {"select":"SurveyStatistics_select__1A32i","textchart":"SurveyStatistics_textchart__24FYm"};